import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DffSideModule, PanelModule } from "@dffedb/ui";

import { KontaktRoutingModule } from "./kontakt-routing.module";
import { KontaktComponent } from "./kontakt.component";

@NgModule({
    imports: [CommonModule, DffSideModule, PanelModule, KontaktRoutingModule],
    declarations: [KontaktComponent]
})
export class EForsyningFeaturesKontaktModule {}
